"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.eventRelayPropType = exports.makeEventRelay = void 0;

var _react = require("react");

var makeEventRelay = function makeEventRelay() {
  var listeners = [];
  var wrappedHandler;

  var handle = function handle(evt) {
    if (typeof wrappedHandler === 'function') wrappedHandler(evt);
    listeners.forEach(function (listener) {
      return listener(evt);
    });
  };

  return {
    getHandle: function getHandle(handler) {
      wrappedHandler = handler;
      return handle;
    },
    subscribe: function subscribe(listener) {
      return listeners.push(listener);
    },
    unsubscribe: function unsubscribe(listener) {
      return listeners.splice(listeners.indexOf(listener), 1);
    }
  };
};

exports.makeEventRelay = makeEventRelay;

var eventRelayPropType = _react.PropTypes.shape({
  subscribe: _react.PropTypes.func.isRequired
});

exports.eventRelayPropType = eventRelayPropType;